// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3uk5U","list":"PatternAutocomplete_list__2qb_V"};